import * as React from 'react';
import { createUseStyles, useTheme } from 'react-jss';

import '../../scss/index.scss';

export interface IFrameMainProps {
}

const useStyles = createUseStyles((theme) => {
    return {
        '@global': {
            ...theme.global,
        },
    };
});

/**
 * Provides CSS for store frame
 */
const FrameMain: React.FunctionComponent<IFrameMainProps> = (props) => {
    const theme = useTheme();
    useStyles({ theme });

    React.useEffect(() => {
        const doc = document.documentElement;
        if (doc) {
            doc.classList.add('global-frame-andbeauty');
        }
        return () => {
            if (doc) {
                doc.classList.remove('global-frame-andbeauty');
            }
        };
    }, []);
    return (
        <React.Fragment/>
    );
};

FrameMain.displayName = 'FrameMain';

export default FrameMain;
